import { connect } from 'react-redux'
import ServiceDays from '../../components/services/edit/ServiceDays'
import { fetchServiceDays, updateServiceDays } from '../../state/actions/services/index'
import { IHolidayItem, IStoreState, IWorkingHoursItem } from '../../types/index'
import { getService } from '../../state/reducers/services/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const serviceId = state.service.metadata.edit.serviceId
  const service = serviceId && getService(state, serviceId)
  return {
    formRef: ownProps.formRef,
    serviceId,
    orgId: state.organizations.currentOrgId,
    workingHoursItems: state.serviceEdit.workingHoursSection.list,
    holidayItems: state.serviceEdit.holidaysSection.list,
    isAllDaysActive: service ? service.isAllDaysActive : true,
    onStepSuccessfullyCompleted: ownProps.onStepSuccessfullyCompleted
  }
}

const mapDispatchToProps = (dispatch: any, ownProps: any) => {
  return {
    onComponentMount: (serviceId: string, orgId: string) => {
      dispatch(fetchServiceDays(serviceId, orgId))
    },
    onUpdateServiceDays: (
      serviceId: string,
      isAllDaysActive: boolean,
      workingHoursItems: IWorkingHoursItem[],
      holidaysItems: IHolidayItem[]
    ) => {
      return dispatch(updateServiceDays(serviceId, !!isAllDaysActive, workingHoursItems, holidaysItems))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceDays)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceDays.ts